import Label, { LabelVariant } from '@/components/elements/Label/Label';
import { useAssocationDrawerContext } from '@/features/associations-drawer/AssociationDrawer.hooks';
import { isSistaminuten as isSistaminutenInstance } from '@/helpers';
import { _t } from '@/locale';
import { SearchPlace } from '@/types/api/services/search';
import { Fragment } from 'react/jsx-runtime';

type CardTagsProps = {
  place: SearchPlace;
  source?: string;
  hideTag?: { [key in LabelVariant]?: boolean };
};

/** Labels must not shrink — overflow with scroll instead of wrapping */
const neutralClass = 'flex-shrink-0 bg-bg_secondary_neutral';

const CardTags = ({ place, hideTag, source }: CardTagsProps) => {
  const associationManager = useAssocationDrawerContext();
  const { about, topSearch, distance, associations } = place;
  const {
    campaign: hideCampaign = false,
    wellness: hideWellness = false,
    discount: hideDiscount = false,
  } = hideTag || {};

  const isSistaminuten = isSistaminutenInstance() || Boolean(place.lastMinuteDiscount);

  const hasDiscount =
    !isSistaminuten && !topSearch && about.settings && about.settings.topOfSearch && source === 'serp-page-top';
  const hasRocket = !isSistaminuten && topSearch;
  const hasCampaign = !isSistaminuten && about?.settings?.hasCampaigns && !hideCampaign;
  const hasSistaminutenDiscount = isSistaminuten && place.lastMinuteDiscount > 0 && !hideDiscount;
  const hasPayLater = about?.settings?.hasKlarna || about?.settings?.hasQliro || place.settings?.payLater;
  const hasGiftCard = about?.settings?.sellsGiftCard;
  const hasWellnessCard = about?.settings?.wellness && !hideWellness;
  const hasAssociation = associations?.length;
  // dont show certificate and association at the same time
  const hasCertificate = !isSistaminuten && about?.settings?.displayCertificates && !hasAssociation;

  const handleShowPlaceAssociations = (e) => {
    e.stopPropagation();
    e.preventDefault();
    associationManager.onOpen(place);
  };

  if (
    hasCampaign ||
    hasRocket ||
    hasDiscount ||
    hasSistaminutenDiscount ||
    hasPayLater ||
    hasCertificate ||
    hasGiftCard ||
    hasWellnessCard ||
    associations?.length ||
    hasAssociation ||
    distance
  ) {
    return (
      <Fragment>
        <div className="gap-xs no-scrollbar rounded-xs flex flex-row overflow-x-scroll sm:flex-wrap">
          {hasSistaminutenDiscount && (
            <Label
              className={neutralClass}
              size="lg"
              variant="discount"
              icon={false}
              label={_t('UpToDiscountPercentage', { discount: place?.lastMinuteDiscount })}
            />
          )}
          {hasDiscount && (
            <Label className={neutralClass} size="lg" variant="discount" icon={false} label={_t('20discount')} />
          )}
          {hasRocket && <Label className={neutralClass} size="lg" variant="rocket" icon={false} />}
          {hasCampaign && <Label className={neutralClass} size="lg" variant="campaign" icon={false} />}
          {hasPayLater && <Label className={neutralClass} size="lg" variant="payLater" icon={false} />}
          {hasCertificate && <Label className={neutralClass} size="lg" variant="certificate" icon={false} />}
          {hasGiftCard && <Label className={neutralClass} size="lg" variant="giftcard" icon={false} />}
          {hasWellnessCard && <Label className={neutralClass} size="lg" variant="wellness" icon={false} />}
          {hasAssociation && (
            <button onClick={handleShowPlaceAssociations} className="inline-flex outline-none">
              <Label className={neutralClass} size="lg" variant="org" />
            </button>
          )}
          {distance && <Label className={neutralClass} size="lg" label={`${distance}`} />}
        </div>
      </Fragment>
    );
  }
  return null;
};

export default CardTags;
